export default __webpack_public_path__ + "0592f647d85fc092e402fdfb77234e24.png";